module.exports = __webpack_public_path__ + "img/copy.e13673ea.svg";